import { render, staticRenderFns } from "./profile-reservations.vue?vue&type=template&id=31b76bb3&"
import script from "./profile-reservations.vue?vue&type=script&lang=js&"
export * from "./profile-reservations.vue?vue&type=script&lang=js&"
import style0 from "./profile-reservations.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports